<template>
  <Button label="Filtros" disabled outlined @click="openRightSidebar" />
</template>
<script setup>
import { ref } from "vue";
import { useSidebar } from "../../composables/useSidebar";

const { openRightSidebar } = useSidebar();
</script>
